<template>
  <v-row>
    <v-col>
      <v-autocomplete
        label="First party"
        :loading="associatedFirstPartiesLoading"
        :items="firstParties"
        item-text="name"
        item-value="id"
        return-object
        :value="accountId"
        @change="onChangeAccount"
      />
      <v-autocomplete
        label="Signatory"
        :loading="signatoriesLoading"
        :disabled="signatoriesLoading"
        :items="signatories"
        item-text="name"
        item-value="id"
        return-object
        :value="userId"
        @change="onChangeUser"
      />
    </v-col>
  </v-row>
</template>
<script>
export default {
  name: 'SignatorySelect',
  props: {
    signatory: { type: Object, default: null }
  },
  data: function () {
    return {
      currentAccountId: null,
      currentAccountName: null
    }
  },
  computed: {
    accountId() {
      return this.signatory ? this.signatory.accountId : null
    },
    userId() {
      return this.signatory ? this.signatory.userId : null
    },
    firstParties() {
      if (this.associatedFirstPartiesLoading || this.appUserLoading) {
        return []
      }
      const { accountId, accountShortName } = this.appUser
      return [{ id: accountId, name: accountShortName }, ...this.associatedFirstParties]
    }
  },
  watch: {
    signatory(newVal, oldVal) {
      if (!oldVal && newVal) {
        this.onChangeAccount({ id: this.accountId })
      }
    }
  },
  mounted() {
    if (this.accountId) {
      this.onChangeAccount({ id: this.accountId })
    }
  },
  beforeCreate() {
    this.mapStates([
      'appUser',
      'associatedFirstParties',
      'associatedFirstPartiesLoading',
      'signatories',
      'signatoriesLoading'
    ])
    this.$store.dispatch('get_associatedFirstParties')
  },
  methods: {
    async onChangeAccount({ id, name }) {
      this.currentAccountId = id
      this.currentAccountName = name
      this.$store.dispatch('get_signatories', id)
    },
    onChangeUser(value) {
      const { id: userId } = value
      this.$emit('change', { userId, accountId: this.currentAccountId })
    }
  }
}
</script>
